<main class="confirmation ic-page" *ngIf="content">
    <header class="confirmation__header">
        <h1 class="confirmation__header-title">{{content.title}}</h1>
    </header>

    @if(status === 'AUTHACCEPTED') {
    <app-info-box [infoBoxText]="content.infoAboutCode" [bordered]="true"></app-info-box>
    }

    <article class="confirmation__article">
        <p class="confirmation__article-description">
            {{content.desc}}
        </p>

        @if(status === 'AUTHACCEPTED') {
        <p class="confirmation__article-code">{{authCode}}</p>
        }
    </article>
    <section class="confirmation__button">
        <ic-ghost-button [disabled]="waitingForData" [width]="250" [type]="GhostButtonType.BIG_SECOND_RANK_FLEX"
            [typeHTML]="'button'" [arrowLeft]="true" [showArrow]="true"><span
                innerHTML="{{ 'FAST_PAYMENTS.CONFIRMATION.backBtn' | translate }}"
                (click)="goToLink()"></span></ic-ghost-button>
        @if(status === 'AUTHACCEPTED') {
        <ic-ghost-button (click)="downloadPdf()" [disabled]="waitingForData" [justifyContent]="'center'" [width]="150"
            [showArrow]="false" [typeHTML]="'button'"><span>{{ 'FAST_PAYMENTS.CONFIRMATION.AUTHACCEPTED.downloadBtn'
                | translate
                }}</span></ic-ghost-button>
        }
    </section>
</main>